import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=374f0b13"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-load_d672686ee9ad59fb23819e1036bcb7c9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports